/* Generado por el instalador. No editar a mano. */
import { lazy } from 'react';
export const PILETA_INSTALLED = true;

export const PiletaPage = lazy(() => import('../pages/PiletaPage'));
export { cargarPileta } from '../services/piletaState';
export { mapaPileta } from '../services/piletaState';
export { getPiletaByHabitacion } from '../services/piletaState';
export { upsertPiletaDevice } from '../services/piletaState';
export type { PiletaDevice } from '../services/piletaApi';
export { default as PiletaDeviceCard } from '../components/pileta/PiletaDeviceCard';
export { patchPiletaDevice as patchPiletaDeviceApi } from '../services/piletaApi';
export { refrescarPileta } from '../services/piletaState';
export { fetchPiletaDevice } from '../services/piletaApi';
export { patchPiletaDeviceLocal } from '../services/piletaState';
export { deletePiletaPolicy } from '../services/piletaApi';
export { deletePiletaDevice } from '../services/piletaApi';
export { getPiletaPolicy } from '../services/piletaApi';
export { upsertPiletaPolicy } from '../services/piletaApi';
export { listPiletaPolicies } from '../services/piletaApi';
export { BOMBA_FUNCS } from '../services/piletaApi';
export { PILETA_FUNCS } from '../services/piletaApi';
export { apagarPiletaSistema } from '../services/piletaApi';
export { controlPiletaFuncion } from '../services/piletaApi';
export { fetchPiletaStatus } from '../services/piletaApi';
export type { PiletaChipsState } from '../services/piletaApi';
export type { PiletaFuncion } from '../services/piletaApi';
export { default as PiletaDiscoveryTab } from '../components/pileta/PiletaDiscoveryTab';
export { default as PiletaDeviceCardSettings } from '../components/pileta/PiletaDeviceCardSettings';
